import { render, staticRenderFns } from "./XzqxUpDateStudent.vue?vue&type=template&id=e01faefa&scoped=true&"
import script from "./XzqxUpDateStudent.vue?vue&type=script&lang=js&"
export * from "./XzqxUpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./XzqxUpDateStudent.vue?vue&type=style&index=0&id=e01faefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01faefa",
  null
  
)

export default component.exports